// GLobals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { FormItem } from '@/components';
import { Input, Select } from '@/ui';

// Helpers
import { BlogPostFormFields } from '../../helpers/types';

const PostSeo = () => {
  const { t } = useTranslation(['common']);

  return (
    <>
      <FormItem label={t('update_page_form_seo_title')} name={[BlogPostFormFields.SEO, 'title']}>
        <Input />
      </FormItem>
      <FormItem label={t('update_page_form_seo_description')} name={[BlogPostFormFields.SEO, 'description']}>
        <Input />
      </FormItem>
      <FormItem label={t('update_page_form_seo_keywords')} name={[BlogPostFormFields.SEO, 'keywords']}>
        <Select dropdownStyle={{ display: 'none' }} mode="tags" suffixIcon={null} />
      </FormItem>
    </>
  );
};

export default PostSeo;
